import { render, staticRenderFns } from "./VMdayTag.vue?vue&type=template&id=677200ac&"
import script from "./VMdayTag.vue?vue&type=script&lang=js&"
export * from "./VMdayTag.vue?vue&type=script&lang=js&"
import style0 from "./VMdayTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports